import Nav from "../components/nav/Nav";
import Hero from "../components/hero/Hero";
import SelectedWork from "../components/work/SelectedWork";
import OtherProjects from "../components/work/OtherProjects";
import GithubActivity from "../components/activity/GithubActivity";
import Skills from "../components/skills/Skills";
import Experience from "../components/experience/Experience";
import Leadership from "../components/leadership/Leadership";
import About from "../components/about/About";
import Contact from "../components/contact/Contact";
import Footer from "../components/footer/Footer";

function Home() {
  return (
    <div>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Nav />
      <main id="main">
        <Hero />
        <Experience />
        <SelectedWork />
        <OtherProjects />
        <GithubActivity />
        <Skills />
        <Leadership />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default Home;
